export default [
  {
    key: 'increasement',
    sortable: false,
    sortField: '',
    label: '#',
    thClass: 'w-50px',
  },
  {
    key: 'username',
    sortable: false,
    label: 'field.username',
    stickyColumn: true,
    variant: 'light',
  },
  {
    key: 'name',
    sortable: false,
    label: 'field.name',
  },
  {
    key: 'amount',
    sortable: false,
    label: 'field.amount',
    tdClass: 'text-right',
  },
  {
    key: 'imageUrl',
    sortable: false,
    label: 'field.screenshot',
    tdClass: 'text-center',
  },
  {
    key: 'createdAt',
    sortable: false,
    sortField: 'createdAt',
    label: 'field.createDate',
  },
  {
    key: 'actions',
    label: 'general.action',
  },
  {
    key: 'status',
    sortable: false,
    sortField: 'status',
    label: 'field.status',
  },
  {
    key: 'verifier',
    label: 'field.verifier',
  },
]
